// Token 风险等级枚举
export enum ETokenRiskLevel {
  UNKNOWN = 0,
  BENIGN = 1,
  WARNING = 2,
  SPAM = 1000, // 垃圾
  MALICIOUS = 1001, // 恶意
  SCAM = 1002 // 诈骗
}

// 判断是否为警告级别（大于等于2但小于1000）
export function isWarningToken(riskLevel: number | undefined): boolean {
  if (!riskLevel) return false
  return riskLevel >= ETokenRiskLevel.WARNING && riskLevel < ETokenRiskLevel.SPAM
}

// 判断是否为垃圾/恶意代币（大于等于1000）
export function isSpamToken(riskLevel: number | undefined): boolean {
  if (!riskLevel) return false
  return riskLevel >= ETokenRiskLevel.SPAM
}

// 获取风险等级的显示文本
export function getRiskLevelText(riskLevel: number | undefined, t: (key: string) => string): string {
  if (!riskLevel) return ''

  if (riskLevel === ETokenRiskLevel.WARNING) {
    return t('newToken')
  } else if (riskLevel === ETokenRiskLevel.SPAM) {
    return t('highRiskToken')
  } else if (riskLevel === ETokenRiskLevel.MALICIOUS) {
    return t('maliciousToken')
  } else if (riskLevel === ETokenRiskLevel.SCAM) {
    return t('scamToken')
  }

  return ''
}

// 获取风险等级的描述文本
export function getRiskLevelDescription(riskLevel: number | undefined, t: (key: string) => string): string {
  if (!riskLevel) return ''

  if (riskLevel === ETokenRiskLevel.WARNING) {
    return t('newTokenDescription')
  } else if (riskLevel === ETokenRiskLevel.SPAM) {
    return t('highRiskTokenDescription')
  } else if (riskLevel === ETokenRiskLevel.MALICIOUS) {
    return t('maliciousTokenDescription')
  } else if (riskLevel === ETokenRiskLevel.SCAM) {
    return t('scamTokenDescription')
  }

  return ''
}
